import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
/* Styles and Images */
import CompanyLogoWhite from "../../assets/img/m-comp-logo-white.png";

export default function VerifyAccount() {
    /* Use States / Setters */
    const navigate = useNavigate();
    const [confirmationUrl, setConfirmationUrl] = useState('');
    const { user, userMetaData } = useAuth();
    
    /* Use Effects */
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const confirmationUrlParam = urlParams.get('confirmation_url');
        if (confirmationUrlParam) {
            setConfirmationUrl(confirmationUrlParam);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Redirect if already logged in
    useEffect(() => {
        if (user && userMetaData) {
            const redirectURL = userMetaData.user_role === 'administrator' ? '/admin/dashboard' : '/dashboard';
            navigate(redirectURL);
        }
    }, [user, userMetaData, navigate]);


    /* Custom Functions */
    async function onSubmit(e){
        e.preventDefault();
    }
    
    return (
        <section className="main-form-section">
            <div className="container">
                <div className="banner-wrapper">
                    <div className="form-section-wrapper">
                        <form onSubmit={onSubmit}>
                            <div className="form-header register-header"><img src={CompanyLogoWhite} alt="Company Logo" /></div>
                            <div className="login-heading">
                                <h2>ACCOUNT VERIFICATION</h2>
                                <p>Click the button below verify your account</p>
                            </div>
                            <div className="form-group">
                                <a href={confirmationUrl} className="submit-button text-center">
                                    Verify My Account
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
